module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/86e15532bf675c4c67915038996b3bf7.gif";